export const LINKS = {
  GLFR_HOME: "https://glfr.com",
  GLFR_APP_DOWNLOAD: "https://app.glfr.com",
  GLFR_SIGNUP: "https://share.hsforms.com/1gmz7WUsbQ3GxbVa6u0NcvA48lov",
};
